(function(){
    'use strict'

    angular.module('app.areas')
    .factory('AreasService', AreasService);

    AreasService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function AreasService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(companiaId){

            var url = apiSettings.apiBaseUrl + 'api/areas/' + companiaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(companiaId, areaId){

            var url = apiSettings.apiBaseUrl + 'api/areas/' + companiaId + '/' + areaId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(area){

            area.id = 0;
            area.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/areas',  
                method: 'POST',  
                data: area
            });  
            return response;
        };

        function update(area){

            area.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/areas',  
                method: 'PUT',  
                data: area
            });  
            return response;
        };

        function remove(area){

            area.companiaId = UserInfoService.getCompaniaId();
            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/areas',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: area
            });  
            return response;
        };

    };

})();